import React from 'react';
import { MessageBox, MessageBoxProps } from 'components/_new/MessageBox';

type BlueQuestionsProps = Omit<MessageBoxProps, 'title' | 'variant'>;

export const BlueQuestions = (props: BlueQuestionsProps) => {
	return <MessageBox variant="blue-questions" {...props} />;
};
